import { observer } from 'mobx-react-lite';
import React from 'react';

import type { Event } from '@feathr/blackbox';
import { useLocalUrl } from '@feathr/extender/state';

import TLDR from '../../TLDR';

interface IProps {
  event?: Event;
}

function EventTLDR({ event }: IProps) {
  const localUrl = useLocalUrl();

  if (event === undefined || event.isPending) {
    return <TLDR isLoading={true} />;
  }
  return (
    <TLDR
      image={event.get('logo')}
      isLoading={false}
      link={localUrl(event.getItemUrl())}
      rowReverse={true}
    >
      {event.get('name')}
    </TLDR>
  );
}

export default observer(EventTLDR);
